<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch', //조회
          ]"
          @btnSearch="btnSearch()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">
                <v-col cols="12" md="2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true }"
                    color="primary"
                    class="required mx-1 rounded-0"
                    item-text="name"
                    item-value="code"
                    :items="codegrList"
                    v-model="codegrSelect"
                    :prepend-inner-icon="'$search'"
                    :label="$t('codegr')"
                    dense
                    outlined
                    multiple
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true }"
                    color="primary"
                    class="required mx-1 rounded-0"
                    item-text="text"
                    item-value="value"
                    :items="userFlagList"
                    v-model="userFlagSelect"
                    :prepend-inner-icon="'$search'"
                    :label="$t('userFlag')"
                    dense
                    outlined
                    multiple
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="6" class="pa-2">
        <i-card-vertical
          style="color: black"
          headerTitle="commonCodeTitle"
          :useBtnList="[
            'btnAdd', //신규
            'btnSave', //저장
            'btnDelete', //삭제
          ]"
          @btnAdd="btnAdd('공통코드')"
          @btnSave="btnSave('공통코드')"
          @btnDelete="btnDelete('공통코드')"
        >
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="bas0010MainGrid"
                  class="listBox"
                  :ref="dxDataGridRef"
                  :data-source="bas0010MainGrid"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :show-borders="true"
                  :width="grid.width"
                  :show-row-lines="true"
                  key-expr="id"
                  :focused-row-enabled="true"
                  :disablePagination="false"
                  :column-hiding-enabled="false"
                  :column-auto-width="true"
                  :on-row-inserted="(e) => e.component.navigateToRow(e.key)"
                  @cellClick="listClick"
                  @editing-start="bas0010EditingStart"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                  <DxSelection mode="single" :allow-select-all="false" />
                  <DxColumn data-field="codegr" :caption="$t('codegr')" width="auto" data-type="string" alignment="center" css-class="devest-grid-header-require">
                    <DxLookup :data-source="codegrList" display-expr="name" value-expr="code" />
                  </DxColumn>

                  <DxColumn data-field="code" :caption="$t('code')" width="auto" data-type="string" alignment="left" css-class="devest-grid-header-require" />
                  <DxColumn data-field="codeName" :caption="$t('codeName')" width="auto" data-type="string" alignment="left" />
                  <DxColumn
                    data-field="userFlag"
                    :caption="$t('Use Flag')"
                    width="auto" 
                    data-type="boolean"
                    alignment="center"
                    edit-cell-template="checkBoxEditor"
                  />
                  <DxColumn data-field="makeDate" :caption="$t('makeDate')" width="auto"  data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="maker" :caption="$t('maker')" width="auto"  data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="editDate" :caption="$t('editDate')" width="auto"  data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="editor" :caption="$t('editor')" width="auto"  data-type="string" alignment="cnter" :allow-editing="false" />
                  <template #checkBoxEditor="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value === 'Y' ? true : false" :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)" />
                    <!-- <DxCheckBox :value="cellInfo.value === 'Y' ? true : false" /> -->
                  </template>
                </DxDataGrid>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
      <v-col cols="6" class="pa-2">
        <i-card-vertical
          headerTitle="commonCodeDetail"
          :useBtnList="[
            'btnAdd', //신규
            'btnSave', //저장
            'btnDelete', //삭제
          ]"
          @btnAdd="btnAdd('공통코드상세')"
          @btnSave="btnSave('공통코드상세')"
          @btnDelete="btnDelete('공통코드상세')"
        >
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="bas0011DetailGrid"
                  class="listBox"
                   key-expr="id"
                  :ref="dxDataGridDetailRef"
                  :data-source="bas0011DetailGrid"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :width="grid.width"
                  :show-row-lines="true"
                  :disablePagination="false"
                  :column-hiding-enabled="false"
                  :on-row-inserted="(e) => e.component.navigateToRow(e.key)"
                  @editing-start="bas0011EditingStart"
                  @cellPrepared="cellPreparedDt"
                >
                  <DxPaging :enabled="false" />

                  <DxEditing :allow-updating="true" :allow-adding="true" mode="cell" />
                  <DxColumn data-field="codegr" :caption="$t('codegr')" width="auto" data-type="string" alignment="center" css-class="devest-grid-header-require" :visible="false">
                    <DxLookup :data-source="codegrList" display-expr="name" value-expr="code" />
                  </DxColumn>
                  <DxColumn data-field="prtCode" :caption="$t('prtCode')" width="auto" data-type="string" alignment="center" css-class="devest-grid-header-require" :allow-editing="false" />
                  <DxColumn
                    data-field="code"
                    :caption="$t('code')"
                    width="auto" 
                    data-type="string"
                    alignment="center"
                    css-class="devest-grid-header-require"
                  />
                  <DxColumn data-field="codeName" :caption="$t('codeName')" width="auto" data-type="string" alignment="left" />
                  <DxColumn data-field="sortFlag" :caption="$t('sortFlag')" width="auto"  data-type="string" alignment="center" />
                      <DxColumn
                    data-field="userFlag"
                    :caption="$t('Use Flag')"
                    width="auto" 
                    data-type="boolean"
                    alignment="center"
                    edit-cell-template="checkBoxEditor"
                  />
                  <DxColumn data-field="makeDate" :caption="$t('makeDate')" width="auto"  data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="maker" :caption="$t('maker')" width="auto"  data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="editDate" :caption="$t('editDate')" width="auto"  data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="editor" :caption="$t('editor')" width="auto"  data-type="string" alignment="center" :allow-editing="false" />
                   <template #checkBoxEditor="{ data: cellInfo }">
                    <!-- <DxCheckBox :value="cellInfo.value === 'Y' ? true : false" /> -->
                    <DxCheckBox :value="cellInfo.value === 'Y' ? true : false" :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)" />
                  </template>
                  <DxSelection select-all-mode="allMode" :show-check-boxes-mode="checkBoxesMode" mode="multiple" />
                </DxDataGrid>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxLookup } from 'devextreme-vue/data-grid'
import themes from 'devextreme/ui/themes'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message

import { getCmCode, getCmChildCode, createCmCode, createCmChildCode, deleteCmCode, deleteCmChildCode } from '@/api/system/cmCodeManage'

import { getCurrentDate } from '@/utils/common.js'

export default {
  name: 'pro0010',
  mixins: [baseview, BaseDataGrid],

  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
  },
  data() {
    return {
      dxDataGridRef: 'dxDataGridRef',
      dxDataGridDetailRef: 'dxDataGridDetailRef',
      bas0010MainGrid: [],
      bas0011DetailGrid: [],
      listClickData: null,
      codeList: [],
      codegrSelect: '',
      userFlagSelect: '',
      userFlagList: [
        {
          text: 'Use',
          value: 'Y',
        },
        { text: 'Unused', value: 'N' },
      ],
      checkBoxesMode: 'always' ,// themes.current().startsWith('material') ? 'always' : 'onClick',
      //공통코드 콤보박스리스트
      codegrList: [],
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.dxDataGridRef)
    },
    gridDetailInstance() {
      return this.GetDataGrid(this.dxDataGridDetailRef)
    },
  },
  methods: {
    getCodeGrList() {
      let param = {
        // comCode: getComCode(),
        code: '',
        codegr: '',
        prtCode: 'GR_CODE',
        userFlag: ''
      }
      getCmChildCode(param).then((res) => {
        if(res.list.length < 1) {
          this.codegrList.push({
            name: 'COM',
            code: 'COM',
            // name: item.sysName,
            // code: item.sysCode,
          })
        } else {
          res.list.forEach((item) => {
          this.codegrList.push({
            name: item.codeName,
            code: item.code,
            // name: item.sysName,
            // code: item.sysCode,
          })
        })
        }
      })
      // .finally(() => {
      //   this.endLoading()

      // })
    },
    // PK 인부분 수정[편집]기능 제어
    bas0010EditingStart(e) {
      if (e.data.__created__ === false) {
        if (
          e.column.dataField === 'codegr' ||
          e.column.dataField === 'code' ||
          e.column.dataField === 'makeDate' ||
          e.column.dataField === 'maker' ||
          e.column.dataField === 'editDate' ||
          e.column.dataField === 'editor'
        ) {
          e.cancel = true
        }
      } else {
        if (
          e.column.dataField === 'makeDate' ||
          e.column.dataField === 'maker' ||
          e.column.dataField === 'editDate' ||
          e.column.dataField === 'editor'
        ) {
          e.cancel = true
        }
      }
    },
    bas0011EditingStart(e) {
      if (e.data.__created__ === false) {
        if (
          e.column.dataField === 'codegr' ||
          e.column.dataField === 'prtCode' ||
          e.column.dataField === 'code' ||
          e.column.dataField === 'makeDate' ||
          e.column.dataField === 'maker' ||
          e.column.dataField === 'editDate' ||
          e.column.dataField === 'editor'
        ) {
          e.cancel = true
        }
      } else {
        if (
          e.column.dataField === 'codegr' ||
          e.column.dataField === 'prtCode' ||
          e.column.dataField === 'makeDate' ||
          e.column.dataField === 'maker' ||
          e.column.dataField === 'editDate' ||
          e.column.dataField === 'editor'
        ) {
          e.cancel = true
        }
      }
    },
    cellPrepared(e) {
      if(e.rowType === 'data') {
        if(e.rowType === 'data' && e.rowIndex >= 0) {
          // console.log('e', e)
          if(!e.data.__created__) {
            if(e.column.dataField === 'codegr' ||
              e.column.dataField === 'code') {
              e.cellElement.classList.add('cancel-editable-cell')
            }
          }
        }
      }
    },
    cellPreparedDt(e) {
      if(e.rowType === 'data') {
        if(e.rowType === 'data' && e.rowIndex >= 0) {
          // console.log('e', e)
          if(!e.data.__created__) {
            if(e.column.dataField === 'code') {
              e.cellElement.classList.add('cancel-editable-cell')
            }
          }
        }
      }
    },
    btnSearch() {
      this.doSearchMainList()
      this.doSearchDetailList()
    },
    doSearchMainList(event) {
      this.bas0010MainGrid = []
      this.listClickData = null
      this.openLoading('searching')
      let params = {}
      if (event) {
        params = {
          codegr: '',
          userFlag: '',
        }
      } else {
        params = {
          codegr: this.codegrSelect.toString(),
          userFlag: this.userFlagSelect.toString(),
        }
      }
      getCmCode(params)
        .then((res) => {
          // console.log('master res.list : ', res.list)
          this.bas0010MainGrid = res.list
          // res.list.forEach((item) => {
          //   for (let i = 0; i < this.codegrList.length; i++) {
          //     if (item.codegr === this.codegrList[i].code) {
          //       item.codegrName = this.codegrList[i].name
          //     }
          //   }
          // })
          // if (event) {
          //   res.list.forEach((item) => {
          //     this.codeList.push({
          //       value: item.code,
          //       text: item.codeName,
          //     })
          //   })
          // }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    doSearchDetailList(e) {
       this.bas0011DetailGrid = [] // 초기화
       if (this.listClickData === null) {
         return
       }
      this.openLoading('searching')
      this.gridDetailInstance.clearSelection()
      let params = {
        codegr: this.listClickData.codegr,
        prtCode: this.listClickData.code,
      }
      // console.log('params', params)
      getCmChildCode(params)
        .then((res) => {
          // console.log('detail res.list : ', res.list)
          // console.log('res', res)
          // console.log('this.listClickData ', this.listClickData )
          // if (this.listClickData === '') {
          //   // console.log('AAA')
          //   this.bas0011DetailGrid = res.list
          // } else {
            // console.log('BBB')
            // let cnt = 0
            // this.bas0011OriginData = 0
            res.list.forEach((e) => {
              // console.log('this.listClickData.codegr : ', this.listClickData.codegr)
              // console.log('e.codegr : ', e.codegr)
              // console.log('this.listClickData.code : ', this.listClickData.code)
              // console.log('e.code : ', e.code)
              if (this.listClickData.codegr === e.codegr && this.listClickData.code === e.prtCode) {
                // e.id = cnt++
                // this.bas0011OriginData = e.id
                this.bas0011DetailGrid.push(e)
              }
            })
          // }
        })
        .finally(() => {
          this.endLoading()
          // console.log(this.bas0011DetailGrid)
        })
    },
    listClick(e) {
      if (e.rowIndex !== -1) {
        this.bas0011DetailGrid = []

        if (e.data) {
          this.listClickData = e.data
        } else {
          this.listClickData = null
        }
        this.doSearchDetailList()
      }
    },
    btnAdd(gbn) {
      if (gbn === '공통코드') {
        let check = this.bas0010MainGrid.findIndex((e) => e.__created__ === true)
        if (check === -1) {
          let newRow = {
            id: (this.bas0010MainGrid.length + 1) + '',
            codegr: '',
            code: '',
            codeName: '',
            userFlag: 'Y',
            makeDate: getCurrentDate(),
            maker: this.$store.state.user.userId,
            editDate: '',
            editor: '',
            __modified__: false,
            __created__: true,
          }
          this.gridMainInstance.newRow(newRow)

          this.gridMainInstance.selectRows(newRow.id, true)
          this.gridMainInstance.option('focusedRowIndex', -1)
        } else {
          notify('신규 행이 존재합니다.', 'error', 1500)
        }
      } else if (gbn === '공통코드상세') {
        if (this.listClickData === null || this.listClickData.__created__ === true) {
          this.vToastify('공통코드를 선택해주세요.', 'warn')
        } else {
          let newRow = {
            id: (this.bas0011DetailGrid.length + 1) + '',
            codegr: this.listClickData.codegr,
            prtCode: this.listClickData.code,
            code: '',
            codeName: '',
            userFlag: 'Y',
            makeDate: getCurrentDate(),
            maker: this.$store.state.user.userId,
            editDate: '',
            editor: '',
            __modified__: false,
            __created__: true,
          }
          this.gridDetailInstance.newRow(newRow)
          this.gridDetailInstance.selectRows(newRow.id, true)

          this.gridDetailInstance.option('focusedRowIndex', -1)

          // console.log('newRow: ', newRow)
        }
      }

      // console.log('this.bas0010MainGrid.length', this.bas0010MainGrid)
      // console.log('this.gridMainInstance', this.gridMainInstance)
      // console.log('this.bas0011DetailGrid.length', this.bas0011DetailGrid)
      // console.log('this.gridDetailInstance', this.gridDetailInstance)
    },
    async btnSave(gbn) {
      let message = ''
      if (gbn === '공통코드') {
        await this.gridMainInstance.saveEditData()
        let selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
        // console.log('selectedMainRows', selectedMainRows)
        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }

        //유효성 체크
        for (let row of selectedMainRows) {
          if (!row.codegr || !row.code) {
            this.vToastify(this.$t('requiredCheck') + '[Codegr, Code]', 'warn')
            // this.vToastify('필수항목 입력하세요.[코드그룹, 코드]', 'warn')
            return
          }
          if (row.__created__ !== true) {
            row.__modified__ = true
            row.editor = this.$store.state.user.userId
          }
        }
        // console.log('beforeCurrent')
        this.vToastifyPrompt(
          this.$t('doSaveData'),
          'info',
          current => {
            // console.log('current', current)
            this.openLoading()
            this.gridMainInstance.beginUpdate()
              // console.log('selectedMainRows', selectedMainRows)
            createCmCode(selectedMainRows, true)
              .then((res) => {
                // console.log('res', res)
                this.doSearchMainList(false)
                message = selectedMainRows[0].__created__ == true ? 'Saved' : 'changed'
                notify(this.$t(message), 'success', 3000)
              })
              .catch((error) => {
                this.vToastify(error, 'warn')
              })
              .finally(() => {
                this.gridMainInstance.endUpdate()
                this.endLoading()
              })
          },
          null,
          true
        )
      } else if (gbn === '공통코드상세') {
        await this.gridDetailInstance.saveEditData()
        let selectedMainRows = await this.gridDetailInstance.getSelectedRowsData()

        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }

        //유효성 체크
        for (var row of selectedMainRows) {
          if (!row.codegr || !row.prtCode || !row.code) {
            this.vToastify(this.$t('requiredCheck') + '[Code group, Parent Cdoe, Code]', 'warn')
            // this.vToastify('필수항목 입력하세요.[코드그룹, 코드, 시스템코드]', 'warn')
            return
          }
          if (row.__created__ !== true) {
            row.__modified__ = true
            row.editor = this.$store.state.user.userId
          }
        }

        this.vToastifyPrompt(
          this.$t('doSaveData'),
          'info',
          current => {
            this.openLoading()
            this.gridDetailInstance.beginUpdate()
            createCmChildCode(selectedMainRows, true)
              .then((res) => {
                this.doSearchDetailList(false)
                message = selectedMainRows[0].__created__ == true ? 'Saved' : 'changed'
                notify(this.$t(message), 'success', 3000)
              })
              .catch((error) => {
                this.vToastify(error, 'warn')
              })
              .finally(() => {
                this.gridDetailInstance.endUpdate()
                this.endLoading()
              })
          },
          null,
          true
        )
      }
    },
    async btnDelete(gbn) {
      let message = ''
      if (gbn === '공통코드') {
        await this.gridMainInstance.saveEditData()
        let selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }

        //유효성 체크
        for (let row of selectedMainRows) {
          if (!row.codegr || !row.code) {
            this.vToastify(this.$t('requiredCheck') + '[Codegr, Code]', 'warn')
            // this.vToastify('필수항목 입력하세요.[코드그룹, 코드]', 'warn')
            return
          }
          if (row.__created__ !== true) {
            row.__modified__ = true
            row.editor = this.$store.state.user.userId
          }
        }
        this.vToastifyPrompt(
          this.$t('doDeleteData'),
          'info',
          current => {
            this.openLoading()
            this.gridMainInstance.beginUpdate()
            selectedMainRows.forEach(item => {
              item.prtCode = item.prtCode ? item.prtCode : ''
            })
            // console.log('selectedMainRows : ', selectedMainRows)
            deleteCmCode(selectedMainRows, true)
              .then((res) => {
                this.doSearchMainList(false)
                message = selectedMainRows[0].__created__ == true ? 'Saved' : 'changed'
                notify(this.$t(message), 'success', 3000)
              })
              .catch((error) => {
                this.vToastify(error, 'warn')
              })
              .finally(() => {
                this.gridMainInstance.endUpdate()
                this.endLoading()
              })
          },
          null,
          true
        )
      } else if (gbn === '공통코드상세') {
        await this.gridDetailInstance.saveEditData()
        let selectedMainRows = await this.gridDetailInstance.getSelectedRowsData()

        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }

        //유효성 체크
        for (var row of selectedMainRows) {
          
          if (row.__created__ !== true) {
            row.__modified__ = true
            row.editor = this.$store.state.user.userId
          }
        }

        this.vToastifyPrompt(
          this.$t('doDeleteData'),
          'info',
          current => {
            this.openLoading()
            this.gridDetailInstance.beginUpdate()
            deleteCmChildCode(selectedMainRows, true)
              .then((res) => {
                this.doSearchDetailList(false)
                message = selectedMainRows[0].__created__ == true ? 'Saved' : 'changed'
                notify(this.$t(message), 'success', 3000)
              })
              .catch((error) => {
                this.vToastify(error, 'warn')
              })
              .finally(() => {
                this.gridDetailInstance.endUpdate()
                this.endLoading()
              })
          },
          null,
          true
        )
      }
    },
  },
  mounted() {
    setTimeout(() => this.gridMainInstance.refresh(), 100)
    this.doSearchMainList(true)
  },
  created() {
    this.getCodeGrList()

  },
  beforeMount() {},
}
</script>
<style lang="less" scoped>
</style>